import { render } from "./DeleteEnrolmentModal.vue?vue&type=template&id=c1f86b52"
import script from "./DeleteEnrolmentModal.vue?vue&type=script&lang=ts"
export * from "./DeleteEnrolmentModal.vue?vue&type=script&lang=ts"
script.render = render

export default script